<template>
    <div class="row">
        <div
            class="col-xs-12"
            :class="{ 'col-md-10 col-sm-9': !wide, 'col-sm-6': wide}"
        >
            <label :for="id">{{ label }}</label>
        </div>
        <div
            class="col-xs-12 text-right"
            :class="{ 'col-md-2 col-sm-3': !wide, 'col-sm-6': wide}"
        >
            <date-picker
                :value="localVal"
                :id="id"
                v-bind="$attrs"
                @input="emitInput"
                :placeholder="placeholder"
            />
            <error
                :name="id"
                :errors="errors"
            />
        </div>
    </div>
</template>

<script>
import UsesErrors from '../../../mixins/UsesErrors';
import DatePicker from "../../DateTimePickerComponent.vue";

export default {
    components: {
        DatePicker,
    },
    mixins: [UsesErrors],
    props: {
        value: {
            required: false,
            default: null
        },
        label: {
            required: true,
            type: String
        },
        id: {
            required: true,
            type: String
        },
        type: {
            required: false,
            type: String,
            default: 'text',
        },
        placeholder: {
            required: false,
            type: String,
            default: 'Type here...',
        },
        wide: {
            default: false,
            type: Boolean,
        },
    },
    data() {
        return {
            localVal: '',
        }
    },
    watch: {
        value: {
            handler() {
                if (this.localVal !== this.value) {
                    this.localVal = this.value;
                }
            },
            immediate: true,
        },
    },
    methods: {
        emitInput(value) {
            if (this.localVal !== value) {
                this.localVal = value;
                this.$emit("input", value);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.row {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/parts/DateRowComponent.vue